import styled from 'styled-components';

const Container = styled.main``;
export default Container;
